import { PocCard } from 'commons/components/components-wrapper';
import { bulkActionButtonContentStyles } from 'commons/components/bulk-action-button/bulk-action-button.style';
import { owcTheme } from 'core/theme/theme.config';
import styled from 'styled-components';

export const BulkActionsLayout = styled(PocCard)`
    position: sticky;
    right: 0;
    bottom: 0;
    z-index: ${owcTheme['one-z-index-header']};
    flex: 0 0 auto;
    width: calc(100%);
    height: 78px;
    overflow: visible !important;

    > * {
        overflow: visible !important;
    }

    > div {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 2px 24px;
    }
`;

export const BulkActionsOptionsLayout = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const BulkActionsActionsLayout = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    .bulk-action {
        ${bulkActionButtonContentStyles}
        *:disabled {
            color: ${owcTheme['one-color-interaction-disabled-base']};
            cursor: not-allowed;
        }

        owc-typography.disabled {
            color: ${owcTheme['one-color-interaction-disabled-base']};
        }
    }
`;
